<template>
  <Nuxt />
</template>

<script>
export default {
  name: 'EmptyLayout',
}
</script>
